import BaseService from '@/service/base';
import { realNameAuth, user } from '@/enums/interfaceEnum';
import { Config } from '@/utils/service/http';
import { useUserStore } from '@/store/modules/user';
import { BenefitsItem } from '@/store/modules/benefits';
import { CYInfo } from '@/views/main/cy';

export default class UserService extends BaseService {
    /**
     * 获取用户随机答题信息
     * @returns
     */
    static getUserSubjectInfo() {
        return this.post(user.GET_USER_SUBJECT_INFO);
    }

    /**
     * 实名认证
     */
    static userAuth(payload: any, config?: Config) {
        return this.post(realNameAuth.USER_AUTH, payload, config);
    }

    /**
     * 查询实名认证信息
     */
    static getStatus(payload: { user_id: string }, config?: Config) {
        return this.get(realNameAuth.STATUS, payload, config);
    }

    /**
     * 获取用户游戏状态
     * @param payload
     * @param config
     */
    static getGameStatus(payload?: any, config?: Config) {
        return this.get(user.GAME_STATUS, payload, config);
    }

    /**
     * 获取用户基本信息
     */
    static getBaseInfo(payload: { user_id: string }, config?: Config) {
        return this.get(user.BASE_INFO, payload, config);
    }

    /**
     * 判断两人是否是好友
     */
    static getIsFriend(payload: { user_id: string }, config?: Config) {
        return this.post(user.IS_FRIEND, payload, config);
    }

    /**
     * 获取勋章列表
     */
    static getMedalList(config?: Config) {
        return this.get(user.MEDAL_LIST, {}, config);
    }

    /**
     * 获取勋章详情
     */
    static getMedalInfo(payload: { sign: string; badgeId: string }, config?: Config) {
        return this.get(user.MEDAL_INFO, payload, config);
    }

    /**
     * 注销
     */
    static logout(config?: Config) {
        return this.post(user.LOGOUT, undefined, config);
    }

    /**
     * 获取等级列表
     */
    static getLevelList(payload: any, config?: Config) {
        return this.get(user.LEVEL_LIST, payload, config);
    }

    /**
     * 获取用户权益列表
     * @param payload
     * @param config
     * @returns
     */
    static getPrivilegeList(config?: Config): Promise<Array<BenefitsItem>> {
        return this.get(user.PRIVILEGE_LIST, {}, config);
    }

    /**
     * 计算CY值
     */
    static getCyInfo(payload = { type: 1 }, config?: Config): Promise<CYInfo> {
        return this.get(user.COUNT_CY_INFO, payload, config);
    }
}
